import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

const LongerWorks = ({ theme, ...props }) => (
  <svg
    aria-labelledby={props.ariaTags.labelledBy}
    aria-hidden={props.ariaTags.hidden}
    className={cx(theme.container, theme[props.svg], props.className)}
    shapeRendering="geometricPrecision"
    tabIndex={props.tabIndex}
    vectorEffect="non-scaling-stroke"
    width="21"
    height="25"
    viewBox="0 0 21 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {props.title ? (
      <title id={props.ariaTags.labelledBy} lang="en">
        {props.title}
      </title>
    ) : null}
    <g className={theme.stroke} fill="none" fillRule="evenodd">
      <path
        d="M6.948 4.87891H14.148"
        stroke="#1E6FD4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.948 7.92188H14.148"
        stroke="#1E6FD4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.948 10.9688H14.148"
        stroke="#1E6FD4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.948 14.0117H14.148"
        stroke="#1E6FD4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.948 17.0547H14.148"
        stroke="#1E6FD4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 0.609375H2.40002V21.9508H18V0.609375Z"
        stroke="#1E6FD4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.80005 22.5591V24.3883H20.4V3.04688H18.6"
        stroke="#1E6FD4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.09998 14.0136C1.27198 14.0136 0.599976 13.3307 0.599976 12.4892C0.599976 11.6478 1.27198 10.9648 2.09998 10.9648H4.19998"
        stroke="#1E6FD4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.09998 8.18941C1.27198 8.18941 0.599976 7.50648 0.599976 6.66502C0.599976 5.82355 1.27198 5.14062 2.09998 5.14062H4.19998"
        stroke="#1E6FD4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.09998 20.1035C1.27198 20.1035 0.599976 19.4205 0.599976 18.5791C0.599976 17.7376 1.27198 17.0547 2.09998 17.0547H4.19998"
        stroke="#1E6FD4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4957_13256">
        <rect width="21" height="25" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

LongerWorks.propTypes = {
  ariaTags: PropTypes.object.isRequired,
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}

export default LongerWorks
